/* eslint-disable */
function isValidEmailAddress(_email) {
  const regEx = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+[^<>()\.,;:\s@\"]{2,})$/
  return regEx.test(_email)
}

const validationHelper = {
  isValidEmailAddress: isValidEmailAddress,
}

export default validationHelper
